var map = {
	"./arrow-right.png": "c768",
	"./assigned/fangxin.png": "0ca0",
	"./assigned/funeng.png": "c25f",
	"./assigned/gaoshouyi.png": "d403",
	"./assigned/hefa.png": "0d6b",
	"./assigned/niuping.png": "38a0",
	"./assigned/siyu.png": "430f",
	"./baopin-sp.png": "b993",
	"./baopin.png": "852f",
	"./chengxin.png": "c57e",
	"./contact-item1.png": "5606",
	"./contact-item2.png": "ee41",
	"./contact-item3.png": "32f6",
	"./gongtongfuyu.png": "70e8",
	"./heguihefa-sp.png": "6269",
	"./heguihefa.png": "f6b2",
	"./jiandantixian-sp.png": "c986",
	"./jiandantixian.png": "6566",
	"./lingyuankaidian-sp.png": "c6e0",
	"./lingyuankaidian.png": "2021",
	"./lita.png": "a078",
	"./logo.png": "e0dd",
	"./merchants/dingdanshuliang.png": "ca31",
	"./merchants/hezuomoshi.png": "d789",
	"./merchants/quanpinlei.png": "b2a5",
	"./merchants/tuihuanhuo.png": "ce53",
	"./merchants/xuankuanhezuo.png": "3a7b",
	"./mianjianchanping-sp.png": "9187",
	"./mianjianchanping.png": "63a6",
	"./position.png": "8d49",
	"./shenhe-sp.png": "32fe",
	"./shenhe.png": "1a47"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";